import React, {Component} from 'react';
import * as Cards from './cards/index'

import './SummaryHeader.css'

class Summary extends Component {
	render() {
		const { stats } = this.props;

		return (
			<div className="summary-header">
				<div className="card-1"><Cards.CardTotalAccessed accessCount={stats.stickerAccessCount}/></div>
				<div className="card-2"><Cards.CardLastAccessed /></div>
				<div className="card-3"><Cards.CardTotalStickers stickerCount={stats.stickerCount} /></div>
			</div>
		);
	}
}

export default Summary;


// WEBPACK FOOTER //
// ./src/components/summary/SummaryHeader.jsx